import { render } from "./OrderSelect.vue?vue&type=template&id=2bb7c0e2&scoped=true"
import script from "./OrderSelect.vue?vue&type=script&lang=js"
export * from "./OrderSelect.vue?vue&type=script&lang=js"

import "./OrderSelect.vue?vue&type=style&index=0&id=2bb7c0e2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb7c0e2"]])

export default __exports__